export default __webpack_public_path__ + "static/media/web-cam.b206952a.png";